// **********************************************************************
// This file was generated by a TAF parser!
// TAF version 2.1.7.9
// Generated from `VideoUIServant.jce'
// **********************************************************************
import { Taf } from "@huyafed/taf-network";
var HUYA = HUYA || {};


HUYA.PresenterVideoMaterialBase = function()
{
    this.lId = 0;
    this.sName = "";
    this.sLogoUrl = "";
    this.sActionUrl = "";
    this.iWeight = 0;
    this.sMd5 = "";
};
HUYA.PresenterVideoMaterialBase.prototype._clone = function () { return new HUYA.PresenterVideoMaterialBase(); }
HUYA.PresenterVideoMaterialBase.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.PresenterVideoMaterialBase.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.PresenterVideoMaterialBase.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lId);
    os.writeString(1, this.sName);
    os.writeString(2, this.sLogoUrl);
    os.writeString(3, this.sActionUrl);
    os.writeInt32(4, this.iWeight);
    os.writeString(5, this.sMd5);
};

HUYA.PresenterVideoMaterialBase.prototype.readFrom = function (is)
{
    this.lId= is.readInt64(0, false, this.lId);
    this.sName= is.readString(1, false, this.sName);
    this.sLogoUrl= is.readString(2, false, this.sLogoUrl);
    this.sActionUrl= is.readString(3, false, this.sActionUrl);
    this.iWeight= is.readInt32(4, false, this.iWeight);
    this.sMd5= is.readString(5, false, this.sMd5);
};

HUYA.VideoSDKMaterial = function()
{
    this.iType = 0;
    this.lId = 0;
    this.sName = "";
    this.sLogoUrl = "";
    this.sFileUrl = "";
    this.sMd5 = "";
    this.lVideoLength = 0;
    this.lTravelId = 0;
    this.sTravelUrl = "";
    this.iWidth = 0;
    this.iHeight = 0;
    this.sFirstClassName = "";
    this.sSecondClassName = "";
};
HUYA.VideoSDKMaterial.prototype._clone = function () { return new HUYA.VideoSDKMaterial(); }
HUYA.VideoSDKMaterial.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.VideoSDKMaterial.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.VideoSDKMaterial.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iType);
    os.writeInt64(1, this.lId);
    os.writeString(2, this.sName);
    os.writeString(3, this.sLogoUrl);
    os.writeString(4, this.sFileUrl);
    os.writeString(5, this.sMd5);
    os.writeInt64(6, this.lVideoLength);
    os.writeInt64(7, this.lTravelId);
    os.writeString(8, this.sTravelUrl);
    os.writeInt32(9, this.iWidth);
    os.writeInt32(10, this.iHeight);
    os.writeString(11, this.sFirstClassName);
    os.writeString(12, this.sSecondClassName);
};

HUYA.VideoSDKMaterial.prototype.readFrom = function (is)
{
    this.iType= is.readInt32(0, false, this.iType);
    this.lId= is.readInt64(1, false, this.lId);
    this.sName= is.readString(2, false, this.sName);
    this.sLogoUrl= is.readString(3, false, this.sLogoUrl);
    this.sFileUrl= is.readString(4, false, this.sFileUrl);
    this.sMd5= is.readString(5, false, this.sMd5);
    this.lVideoLength= is.readInt64(6, false, this.lVideoLength);
    this.lTravelId= is.readInt64(7, false, this.lTravelId);
    this.sTravelUrl= is.readString(8, false, this.sTravelUrl);
    this.iWidth= is.readInt32(9, false, this.iWidth);
    this.iHeight= is.readInt32(10, false, this.iHeight);
    this.sFirstClassName= is.readString(11, false, this.sFirstClassName);
    this.sSecondClassName= is.readString(12, false, this.sSecondClassName);
};

HUYA.PresenterVideoMaterialVideo = function()
{
    this.tBase = new HUYA.PresenterVideoMaterialBase();
    this.lVideoLength = 0;
    this.lTravelId = 0;
    this.sTravelUrl = "";
    this.iWidth = 0;
    this.iHeight = 0;
};
HUYA.PresenterVideoMaterialVideo.prototype._clone = function () { return new HUYA.PresenterVideoMaterialVideo(); }
HUYA.PresenterVideoMaterialVideo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.PresenterVideoMaterialVideo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.PresenterVideoMaterialVideo.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tBase);
    os.writeInt64(1, this.lVideoLength);
    os.writeInt64(2, this.lTravelId);
    os.writeString(3, this.sTravelUrl);
    os.writeInt32(4, this.iWidth);
    os.writeInt32(5, this.iHeight);
};

HUYA.PresenterVideoMaterialVideo.prototype.readFrom = function (is)
{
    this.tBase= is.readStruct(0, false, this.tBase);
    this.lVideoLength= is.readInt64(1, false, this.lVideoLength);
    this.lTravelId= is.readInt64(2, false, this.lTravelId);
    this.sTravelUrl= is.readString(3, false, this.sTravelUrl);
    this.iWidth= is.readInt32(4, false, this.iWidth);
    this.iHeight= is.readInt32(5, false, this.iHeight);
};

HUYA.PresenterVideoMaterialPaster = function()
{
    this.tBase = new HUYA.PresenterVideoMaterialBase();
};
HUYA.PresenterVideoMaterialPaster.prototype._clone = function () { return new HUYA.PresenterVideoMaterialPaster(); }
HUYA.PresenterVideoMaterialPaster.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.PresenterVideoMaterialPaster.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.PresenterVideoMaterialPaster.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tBase);
};

HUYA.PresenterVideoMaterialPaster.prototype.readFrom = function (is)
{
    this.tBase= is.readStruct(0, false, this.tBase);
};

HUYA.PresenterVideoMaterialAudio = function()
{
    this.tBase = new HUYA.PresenterVideoMaterialBase();
};
HUYA.PresenterVideoMaterialAudio.prototype._clone = function () { return new HUYA.PresenterVideoMaterialAudio(); }
HUYA.PresenterVideoMaterialAudio.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.PresenterVideoMaterialAudio.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.PresenterVideoMaterialAudio.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tBase);
};

HUYA.PresenterVideoMaterialAudio.prototype.readFrom = function (is)
{
    this.tBase= is.readStruct(0, false, this.tBase);
};

HUYA.PresenterCoverModuleMaterial = function()
{
    this.tBase = new HUYA.PresenterVideoMaterialBase();
};
HUYA.PresenterCoverModuleMaterial.prototype._clone = function () { return new HUYA.PresenterCoverModuleMaterial(); }
HUYA.PresenterCoverModuleMaterial.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.PresenterCoverModuleMaterial.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.PresenterCoverModuleMaterial.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tBase);
};

HUYA.PresenterCoverModuleMaterial.prototype.readFrom = function (is)
{
    this.tBase= is.readStruct(0, false, this.tBase);
};

HUYA.VDCommRsp = function()
{
    this.iRet = 0;
    this.sDes = "";
};
HUYA.VDCommRsp.prototype._clone = function () { return new HUYA.VDCommRsp(); }
HUYA.VDCommRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.VDCommRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.VDCommRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iRet);
    os.writeString(1, this.sDes);
};

HUYA.VDCommRsp.prototype.readFrom = function (is)
{
    this.iRet= is.readInt32(0, false, this.iRet);
    this.sDes= is.readString(1, false, this.sDes);
};

HUYA.UserId = function()
{
    this.lUid = 0;
    this.sGuid = "";
    this.sToken = "";
    this.sHuYaUA = "";
    this.sCookie = "";
    this.iTokenType = 0;
    this.sDeviceInfo = "";
    this.sQIMEI = "";
};
HUYA.UserId.prototype._clone = function () { return new HUYA.UserId(); }
HUYA.UserId.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserId.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserId.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sGuid);
    os.writeString(2, this.sToken);
    os.writeString(3, this.sHuYaUA);
    os.writeString(4, this.sCookie);
    os.writeInt32(5, this.iTokenType);
    os.writeString(6, this.sDeviceInfo);
    os.writeString(7, this.sQIMEI);
};

HUYA.UserId.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.sGuid= is.readString(1, false, this.sGuid);
    this.sToken= is.readString(2, false, this.sToken);
    this.sHuYaUA= is.readString(3, false, this.sHuYaUA);
    this.sCookie= is.readString(4, false, this.sCookie);
    this.iTokenType= is.readInt32(5, false, this.iTokenType);
    this.sDeviceInfo= is.readString(6, false, this.sDeviceInfo);
    this.sQIMEI= is.readString(7, false, this.sQIMEI);
};

HUYA.VideoStatInfo = function()
{
    this.mVid2SubCount = new Taf.Map(new Taf.STRING(), new Taf.INT64());
    this.mVid2SubDuration = new Taf.Map(new Taf.STRING(), new Taf.INT64());
    this.mVid2ClickNum = new Taf.Map(new Taf.STRING(), new Taf.INT64());
    this.mVid2RealViewNum = new Taf.Map(new Taf.STRING(), new Taf.INT64());
};
HUYA.VideoStatInfo.prototype._clone = function () { return new HUYA.VideoStatInfo(); }
HUYA.VideoStatInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.VideoStatInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.VideoStatInfo.prototype.writeTo = function (os)
{
    os.writeMap(0, this.mVid2SubCount);
    os.writeMap(1, this.mVid2SubDuration);
    os.writeMap(4, this.mVid2ClickNum);
    os.writeMap(5, this.mVid2RealViewNum);
};

HUYA.VideoStatInfo.prototype.readFrom = function (is)
{
    this.mVid2SubCount= is.readMap(0, false, this.mVid2SubCount);
    this.mVid2SubDuration= is.readMap(1, false, this.mVid2SubDuration);
    this.mVid2ClickNum= is.readMap(4, false, this.mVid2ClickNum);
    this.mVid2RealViewNum= is.readMap(5, false, this.mVid2RealViewNum);
};

HUYA.VideoSDKMaterialPlayModeItem = function()
{
    this.iType = 0;
    this.sLogoUrl = "";
    this.sTitle = "";
    this.sWebURL = "";
    this.sData = "";
};
HUYA.VideoSDKMaterialPlayModeItem.prototype._clone = function () { return new HUYA.VideoSDKMaterialPlayModeItem(); }
HUYA.VideoSDKMaterialPlayModeItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.VideoSDKMaterialPlayModeItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.VideoSDKMaterialPlayModeItem.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iType);
    os.writeString(1, this.sLogoUrl);
    os.writeString(2, this.sTitle);
    os.writeString(3, this.sWebURL);
    os.writeString(4, this.sData);
};

HUYA.VideoSDKMaterialPlayModeItem.prototype.readFrom = function (is)
{
    this.iType= is.readInt32(0, false, this.iType);
    this.sLogoUrl= is.readString(1, false, this.sLogoUrl);
    this.sTitle= is.readString(2, false, this.sTitle);
    this.sWebURL= is.readString(3, false, this.sWebURL);
    this.sData= is.readString(4, false, this.sData);
};

HUYA.VideoSDKMaterialClass = function()
{
    this.sId = "";
    this.sName = "";
    this.vMaterial = new Taf.Vector(new HUYA.VideoSDKMaterial());
    this.vSubClass = new Taf.Vector(HUYA.VideoSDKMaterialClass);
    this.iMaterialCount = 0;
};
HUYA.VideoSDKMaterialClass.prototype._clone = function () { return new HUYA.VideoSDKMaterialClass(); }
HUYA.VideoSDKMaterialClass.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.VideoSDKMaterialClass.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.VideoSDKMaterialClass.prototype.writeTo = function (os)
{
    os.writeString(0, this.sId);
    os.writeString(1, this.sName);
    os.writeVector(2, this.vMaterial);
    os.writeVector(3, this.vSubClass);
    os.writeInt32(4, this.iMaterialCount);
};

HUYA.VideoSDKMaterialClass.prototype.readFrom = function (is)
{
    this.sId= is.readString(0, false, this.sId);
    this.sName= is.readString(1, false, this.sName);
    this.vMaterial= is.readVector(2, false, this.vMaterial);
    this.vSubClass= is.readVector(3, false, this.vSubClass);
    this.iMaterialCount= is.readInt32(4, false, this.iMaterialCount);
};

HUYA.PresenterVideoMaterial = function()
{
    this.iType = 0;
    this.iLevel = 0;
    this.sName = "";
    this.vSub = new Taf.Vector(HUYA.PresenterVideoMaterial);
    this.vVideo = new Taf.Vector(new HUYA.PresenterVideoMaterialVideo());
    this.vPaster = new Taf.Vector(new HUYA.PresenterVideoMaterialPaster());
    this.vAudio = new Taf.Vector(new HUYA.PresenterVideoMaterialAudio());
    this.vCover = new Taf.Vector(new HUYA.PresenterCoverModuleMaterial());
};
HUYA.PresenterVideoMaterial.prototype._clone = function () { return new HUYA.PresenterVideoMaterial(); }
HUYA.PresenterVideoMaterial.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.PresenterVideoMaterial.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.PresenterVideoMaterial.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iType);
    os.writeInt32(1, this.iLevel);
    os.writeString(2, this.sName);
    os.writeVector(3, this.vSub);
    os.writeVector(4, this.vVideo);
    os.writeVector(5, this.vPaster);
    os.writeVector(6, this.vAudio);
    os.writeVector(7, this.vCover);
};

HUYA.PresenterVideoMaterial.prototype.readFrom = function (is)
{
    this.iType= is.readInt32(0, false, this.iType);
    this.iLevel= is.readInt32(1, false, this.iLevel);
    this.sName= is.readString(2, false, this.sName);
    this.vSub= is.readVector(3, false, this.vSub);
    this.vVideo= is.readVector(4, false, this.vVideo);
    this.vPaster= is.readVector(5, false, this.vPaster);
    this.vAudio= is.readVector(6, false, this.vAudio);
    this.vCover= is.readVector(7, false, this.vCover);
};

HUYA.UserViewVideoRsp = function()
{
    this.tRsp = new HUYA.VDCommRsp();
    this.sViewId = "";
    this.iHeartbeatFre = 0;
};
HUYA.UserViewVideoRsp.prototype._clone = function () { return new HUYA.UserViewVideoRsp(); }
HUYA.UserViewVideoRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserViewVideoRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserViewVideoRsp.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tRsp);
    os.writeString(1, this.sViewId);
    os.writeInt32(2, this.iHeartbeatFre);
};

HUYA.UserViewVideoRsp.prototype.readFrom = function (is)
{
    this.tRsp= is.readStruct(0, false, this.tRsp);
    this.sViewId= is.readString(1, false, this.sViewId);
    this.iHeartbeatFre= is.readInt32(2, false, this.iHeartbeatFre);
};

HUYA.UserViewVideoReq = function()
{
    this.tId = new HUYA.UserId();
    this.sVideoId = "";
    this.sdid = "";
    this.iIsPlayPage = 0;
};
HUYA.UserViewVideoReq.prototype._clone = function () { return new HUYA.UserViewVideoReq(); }
HUYA.UserViewVideoReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserViewVideoReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserViewVideoReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeString(1, this.sVideoId);
    os.writeString(2, this.sdid);
    os.writeInt32(3, this.iIsPlayPage);
};

HUYA.UserViewVideoReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.sVideoId= is.readString(1, false, this.sVideoId);
    this.sdid= is.readString(2, false, this.sdid);
    this.iIsPlayPage= is.readInt32(3, false, this.iIsPlayPage);
};

HUYA.UserViewVideoHeartBeatRsp = function()
{
    this.tRsp = new HUYA.VDCommRsp();
    this.sViewId = "";
};
HUYA.UserViewVideoHeartBeatRsp.prototype._clone = function () { return new HUYA.UserViewVideoHeartBeatRsp(); }
HUYA.UserViewVideoHeartBeatRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserViewVideoHeartBeatRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserViewVideoHeartBeatRsp.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tRsp);
    os.writeString(1, this.sViewId);
};

HUYA.UserViewVideoHeartBeatRsp.prototype.readFrom = function (is)
{
    this.tRsp= is.readStruct(0, false, this.tRsp);
    this.sViewId= is.readString(1, false, this.sViewId);
};

HUYA.UserViewVideoHeartBeatReq = function()
{
    this.tId = new HUYA.UserId();
    this.sVideoId = "";
    this.sViewId = "";
    this.sdid = "";
    this.mExt = new Taf.Map(new Taf.STRING(), new Taf.STRING());
    this.iState = 0;
    this.lCurPos = 0;
    this.iIsPlayPage = 0;
};
HUYA.UserViewVideoHeartBeatReq.prototype._clone = function () { return new HUYA.UserViewVideoHeartBeatReq(); }
HUYA.UserViewVideoHeartBeatReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserViewVideoHeartBeatReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserViewVideoHeartBeatReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeString(1, this.sVideoId);
    os.writeString(2, this.sViewId);
    os.writeString(3, this.sdid);
    os.writeMap(5, this.mExt);
    os.writeInt32(6, this.iState);
    os.writeInt64(8, this.lCurPos);
    os.writeInt32(9, this.iIsPlayPage);
};

HUYA.UserViewVideoHeartBeatReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.sVideoId= is.readString(1, false, this.sVideoId);
    this.sViewId= is.readString(2, false, this.sViewId);
    this.sdid= is.readString(3, false, this.sdid);
    this.mExt= is.readMap(5, false, this.mExt);
    this.iState= is.readInt32(6, false, this.iState);
    this.lCurPos= is.readInt64(8, false, this.lCurPos);
    this.iIsPlayPage= is.readInt32(9, false, this.iIsPlayPage);
};

HUYA.UserViewVideoEndRsp = function()
{
    this.tRsp = new HUYA.VDCommRsp();
};
HUYA.UserViewVideoEndRsp.prototype._clone = function () { return new HUYA.UserViewVideoEndRsp(); }
HUYA.UserViewVideoEndRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserViewVideoEndRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserViewVideoEndRsp.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tRsp);
};

HUYA.UserViewVideoEndRsp.prototype.readFrom = function (is)
{
    this.tRsp= is.readStruct(0, false, this.tRsp);
};

HUYA.UserViewVideoEndReq = function()
{
    this.tId = new HUYA.UserId();
    this.sVideoId = "";
    this.sViewId = "";
    this.sdid = "";
    this.iIsPlayPage = 0;
};
HUYA.UserViewVideoEndReq.prototype._clone = function () { return new HUYA.UserViewVideoEndReq(); }
HUYA.UserViewVideoEndReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserViewVideoEndReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserViewVideoEndReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeString(1, this.sVideoId);
    os.writeString(2, this.sViewId);
    os.writeString(3, this.sdid);
    os.writeInt32(4, this.iIsPlayPage);
};

HUYA.UserViewVideoEndReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.sVideoId= is.readString(1, false, this.sVideoId);
    this.sViewId= is.readString(2, false, this.sViewId);
    this.sdid= is.readString(3, false, this.sdid);
    this.iIsPlayPage= is.readInt32(4, false, this.iIsPlayPage);
};

HUYA.UserRealPlayVideoRsp = function()
{
    this.tRsp = new HUYA.VDCommRsp();
};
HUYA.UserRealPlayVideoRsp.prototype._clone = function () { return new HUYA.UserRealPlayVideoRsp(); }
HUYA.UserRealPlayVideoRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserRealPlayVideoRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserRealPlayVideoRsp.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tRsp);
};

HUYA.UserRealPlayVideoRsp.prototype.readFrom = function (is)
{
    this.tRsp= is.readStruct(0, false, this.tRsp);
};

HUYA.UserRealPlayVideoReq = function()
{
    this.tId = new HUYA.UserId();
    this.sVideoId = "";
    this.sdid = "";
    this.iIsPlayPage = 0;
};
HUYA.UserRealPlayVideoReq.prototype._clone = function () { return new HUYA.UserRealPlayVideoReq(); }
HUYA.UserRealPlayVideoReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserRealPlayVideoReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserRealPlayVideoReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeString(1, this.sVideoId);
    os.writeString(2, this.sdid);
    os.writeInt32(3, this.iIsPlayPage);
};

HUYA.UserRealPlayVideoReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.sVideoId= is.readString(1, false, this.sVideoId);
    this.sdid= is.readString(2, false, this.sdid);
    this.iIsPlayPage= is.readInt32(3, false, this.iIsPlayPage);
};

HUYA.UserClickVideoRsp = function()
{
    this.tRsp = new HUYA.VDCommRsp();
};
HUYA.UserClickVideoRsp.prototype._clone = function () { return new HUYA.UserClickVideoRsp(); }
HUYA.UserClickVideoRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserClickVideoRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserClickVideoRsp.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tRsp);
};

HUYA.UserClickVideoRsp.prototype.readFrom = function (is)
{
    this.tRsp= is.readStruct(0, false, this.tRsp);
};

HUYA.UserClickVideoReq = function()
{
    this.tId = new HUYA.UserId();
    this.sVideoId = "";
    this.sdid = "";
    this.iIsPlayPage = 0;
};
HUYA.UserClickVideoReq.prototype._clone = function () { return new HUYA.UserClickVideoReq(); }
HUYA.UserClickVideoReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserClickVideoReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserClickVideoReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeString(1, this.sVideoId);
    os.writeString(2, this.sdid);
    os.writeInt32(3, this.iIsPlayPage);
};

HUYA.UserClickVideoReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.sVideoId= is.readString(1, false, this.sVideoId);
    this.sdid= is.readString(2, false, this.sdid);
    this.iIsPlayPage= is.readInt32(3, false, this.iIsPlayPage);
};

HUYA.UserBehaviorRsp = function()
{
    this.tRsp = new HUYA.VDCommRsp();
};
HUYA.UserBehaviorRsp.prototype._clone = function () { return new HUYA.UserBehaviorRsp(); }
HUYA.UserBehaviorRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserBehaviorRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserBehaviorRsp.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tRsp);
};

HUYA.UserBehaviorRsp.prototype.readFrom = function (is)
{
    this.tRsp= is.readStruct(0, false, this.tRsp);
};

HUYA.UserBehaviorReq = function()
{
    this.tId = new HUYA.UserId();
    this.sVideoId = "";
    this.sViewId = "";
    this.mBehavior = new Taf.Map(new Taf.INT32(), new Taf.STRING());
    this.sdid = "";
    this.iIsPlayPage = 0;
};
HUYA.UserBehaviorReq.prototype._clone = function () { return new HUYA.UserBehaviorReq(); }
HUYA.UserBehaviorReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserBehaviorReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserBehaviorReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeString(1, this.sVideoId);
    os.writeString(2, this.sViewId);
    os.writeMap(4, this.mBehavior);
    os.writeString(5, this.sdid);
    os.writeInt32(6, this.iIsPlayPage);
};

HUYA.UserBehaviorReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.sVideoId= is.readString(1, false, this.sVideoId);
    this.sViewId= is.readString(2, false, this.sViewId);
    this.mBehavior= is.readMap(4, false, this.mBehavior);
    this.sdid= is.readString(5, false, this.sdid);
    this.iIsPlayPage= is.readInt32(6, false, this.iIsPlayPage);
};

HUYA.SearchVideoSDKMaterialReq = function()
{
    this.tId = new HUYA.UserId();
    this.lPkgId = 0;
    this.iMaterialType = 0;
    this.sKeyword = "";
};
HUYA.SearchVideoSDKMaterialReq.prototype._clone = function () { return new HUYA.SearchVideoSDKMaterialReq(); }
HUYA.SearchVideoSDKMaterialReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.SearchVideoSDKMaterialReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.SearchVideoSDKMaterialReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeInt64(1, this.lPkgId);
    os.writeInt32(2, this.iMaterialType);
    os.writeString(3, this.sKeyword);
};

HUYA.SearchVideoSDKMaterialReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.lPkgId= is.readInt64(1, false, this.lPkgId);
    this.iMaterialType= is.readInt32(2, false, this.iMaterialType);
    this.sKeyword= is.readString(3, false, this.sKeyword);
};

HUYA.GetVideoStatBatchRsp = function()
{
    this.tVid2Info = new HUYA.VideoStatInfo();
};
HUYA.GetVideoStatBatchRsp.prototype._clone = function () { return new HUYA.GetVideoStatBatchRsp(); }
HUYA.GetVideoStatBatchRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GetVideoStatBatchRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GetVideoStatBatchRsp.prototype.writeTo = function (os)
{
    os.writeStruct(1, this.tVid2Info);
};

HUYA.GetVideoStatBatchRsp.prototype.readFrom = function (is)
{
    this.tVid2Info= is.readStruct(1, false, this.tVid2Info);
};

HUYA.GetVideoStatBatchReq = function()
{
    this.vVideoId = new Taf.Vector(new Taf.STRING());
    this.tId = new HUYA.UserId();
    this.lUid = 0;
};
HUYA.GetVideoStatBatchReq.prototype._clone = function () { return new HUYA.GetVideoStatBatchReq(); }
HUYA.GetVideoStatBatchReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GetVideoStatBatchReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GetVideoStatBatchReq.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vVideoId);
    os.writeStruct(1, this.tId);
    os.writeInt64(2, this.lUid);
};

HUYA.GetVideoStatBatchReq.prototype.readFrom = function (is)
{
    this.vVideoId= is.readVector(0, false, this.vVideoId);
    this.tId= is.readStruct(1, false, this.tId);
    this.lUid= is.readInt64(2, false, this.lUid);
};

HUYA.GetVideoSDKMaterialPlayModeRsp = function()
{
    this.vItem = new Taf.Vector(new HUYA.VideoSDKMaterialPlayModeItem());
};
HUYA.GetVideoSDKMaterialPlayModeRsp.prototype._clone = function () { return new HUYA.GetVideoSDKMaterialPlayModeRsp(); }
HUYA.GetVideoSDKMaterialPlayModeRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GetVideoSDKMaterialPlayModeRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GetVideoSDKMaterialPlayModeRsp.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vItem);
};

HUYA.GetVideoSDKMaterialPlayModeRsp.prototype.readFrom = function (is)
{
    this.vItem= is.readVector(0, false, this.vItem);
};

HUYA.GetVideoSDKMaterialPlayModeReq = function()
{
    this.tId = new HUYA.UserId();
    this.lPkgId = 0;
    this.sVideoSdkVersion = "";
};
HUYA.GetVideoSDKMaterialPlayModeReq.prototype._clone = function () { return new HUYA.GetVideoSDKMaterialPlayModeReq(); }
HUYA.GetVideoSDKMaterialPlayModeReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GetVideoSDKMaterialPlayModeReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GetVideoSDKMaterialPlayModeReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeInt64(1, this.lPkgId);
    os.writeString(2, this.sVideoSdkVersion);
};

HUYA.GetVideoSDKMaterialPlayModeReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.lPkgId= is.readInt64(1, false, this.lPkgId);
    this.sVideoSdkVersion= is.readString(2, false, this.sVideoSdkVersion);
};

HUYA.GetVideoSDKMaterialPkgAbstractRsp = function()
{
    this.sMessage = "";
    this.vVideoClassTree = new Taf.Vector(new HUYA.VideoSDKMaterialClass());
    this.vPasterClassTree = new Taf.Vector(new HUYA.VideoSDKMaterialClass());
    this.vAudioClassTree = new Taf.Vector(new HUYA.VideoSDKMaterialClass());
    this.sQuickFunc = "";
    this.vCoverClassTree = new Taf.Vector(new HUYA.VideoSDKMaterialClass());
    this.vBubbleTextTree = new Taf.Vector(new HUYA.VideoSDKMaterialClass());
    this.vColorTextTree = new Taf.Vector(new HUYA.VideoSDKMaterialClass());
    this.vAnimationTextTree = new Taf.Vector(new HUYA.VideoSDKMaterialClass());
};
HUYA.GetVideoSDKMaterialPkgAbstractRsp.prototype._clone = function () { return new HUYA.GetVideoSDKMaterialPkgAbstractRsp(); }
HUYA.GetVideoSDKMaterialPkgAbstractRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GetVideoSDKMaterialPkgAbstractRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GetVideoSDKMaterialPkgAbstractRsp.prototype.writeTo = function (os)
{
    os.writeString(0, this.sMessage);
    os.writeVector(1, this.vVideoClassTree);
    os.writeVector(2, this.vPasterClassTree);
    os.writeVector(3, this.vAudioClassTree);
    os.writeString(4, this.sQuickFunc);
    os.writeVector(6, this.vCoverClassTree);
    os.writeVector(7, this.vBubbleTextTree);
    os.writeVector(8, this.vColorTextTree);
    os.writeVector(9, this.vAnimationTextTree);
};

HUYA.GetVideoSDKMaterialPkgAbstractRsp.prototype.readFrom = function (is)
{
    this.sMessage= is.readString(0, false, this.sMessage);
    this.vVideoClassTree= is.readVector(1, false, this.vVideoClassTree);
    this.vPasterClassTree= is.readVector(2, false, this.vPasterClassTree);
    this.vAudioClassTree= is.readVector(3, false, this.vAudioClassTree);
    this.sQuickFunc= is.readString(4, false, this.sQuickFunc);
    this.vCoverClassTree= is.readVector(6, false, this.vCoverClassTree);
    this.vBubbleTextTree= is.readVector(7, false, this.vBubbleTextTree);
    this.vColorTextTree= is.readVector(8, false, this.vColorTextTree);
    this.vAnimationTextTree= is.readVector(9, false, this.vAnimationTextTree);
};

HUYA.GetVideoSDKMaterialPkgAbstractReq = function()
{
    this.tId = new HUYA.UserId();
    this.lPkgId = 0;
    this.iMaterialType = 0;
};
HUYA.GetVideoSDKMaterialPkgAbstractReq.prototype._clone = function () { return new HUYA.GetVideoSDKMaterialPkgAbstractReq(); }
HUYA.GetVideoSDKMaterialPkgAbstractReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GetVideoSDKMaterialPkgAbstractReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GetVideoSDKMaterialPkgAbstractReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeInt64(1, this.lPkgId);
    os.writeInt32(2, this.iMaterialType);
};

HUYA.GetVideoSDKMaterialPkgAbstractReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.lPkgId= is.readInt64(1, false, this.lPkgId);
    this.iMaterialType= is.readInt32(2, false, this.iMaterialType);
};

HUYA.GetVideoSDKMaterialListRsp = function()
{
    this.vMaterial = new Taf.Vector(new HUYA.VideoSDKMaterial());
    this.iHasMore = 0;
    this.sMessage = "";
};
HUYA.GetVideoSDKMaterialListRsp.prototype._clone = function () { return new HUYA.GetVideoSDKMaterialListRsp(); }
HUYA.GetVideoSDKMaterialListRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GetVideoSDKMaterialListRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GetVideoSDKMaterialListRsp.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vMaterial);
    os.writeInt32(1, this.iHasMore);
    os.writeString(2, this.sMessage);
};

HUYA.GetVideoSDKMaterialListRsp.prototype.readFrom = function (is)
{
    this.vMaterial= is.readVector(0, false, this.vMaterial);
    this.iHasMore= is.readInt32(1, false, this.iHasMore);
    this.sMessage= is.readString(2, false, this.sMessage);
};

HUYA.GetVideoSDKMaterialListReq = function()
{
    this.tId = new HUYA.UserId();
    this.lPkgId = 0;
    this.iMaterialType = 0;
    this.sFirstClassId = "";
    this.sSecondClassId = "";
    this.iPage = 0;
};
HUYA.GetVideoSDKMaterialListReq.prototype._clone = function () { return new HUYA.GetVideoSDKMaterialListReq(); }
HUYA.GetVideoSDKMaterialListReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GetVideoSDKMaterialListReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GetVideoSDKMaterialListReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeInt64(1, this.lPkgId);
    os.writeInt32(2, this.iMaterialType);
    os.writeString(3, this.sFirstClassId);
    os.writeString(4, this.sSecondClassId);
    os.writeInt32(5, this.iPage);
};

HUYA.GetVideoSDKMaterialListReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.lPkgId= is.readInt64(1, false, this.lPkgId);
    this.iMaterialType= is.readInt32(2, false, this.iMaterialType);
    this.sFirstClassId= is.readString(3, false, this.sFirstClassId);
    this.sSecondClassId= is.readString(4, false, this.sSecondClassId);
    this.iPage= is.readInt32(5, false, this.iPage);
};

HUYA.GetPresenterVideoMaterialRsp = function()
{
    this.vMaterial = new Taf.Vector(new HUYA.PresenterVideoMaterial());
};
HUYA.GetPresenterVideoMaterialRsp.prototype._clone = function () { return new HUYA.GetPresenterVideoMaterialRsp(); }
HUYA.GetPresenterVideoMaterialRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GetPresenterVideoMaterialRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GetPresenterVideoMaterialRsp.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vMaterial);
};

HUYA.GetPresenterVideoMaterialRsp.prototype.readFrom = function (is)
{
    this.vMaterial= is.readVector(0, false, this.vMaterial);
};

HUYA.GetPresenterVideoMaterialReq = function()
{
    this.tId = new HUYA.UserId();
    this.lMaterialId = 0;
    this.iType = 0;
};
HUYA.GetPresenterVideoMaterialReq.prototype._clone = function () { return new HUYA.GetPresenterVideoMaterialReq(); }
HUYA.GetPresenterVideoMaterialReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GetPresenterVideoMaterialReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GetPresenterVideoMaterialReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeInt64(1, this.lMaterialId);
    os.writeInt32(2, this.iType);
};

HUYA.GetPresenterVideoMaterialReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.lMaterialId= is.readInt64(1, false, this.lMaterialId);
    this.iType= is.readInt32(2, false, this.iType);
};


export default HUYA;